import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType } from "vue"
  import { Vehicle } from "src/types/loan-application/index";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleAvatar',
  props: {
    vehicle: {
      type: Object as PropType<Vehicle>,
      default: null
    },
    size: {
      type: String,
      default: "60px"
    },
    approved: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {

const props = __props

  function vehicleImage(vehicle: Vehicle) {

    if (!vehicle || !vehicle.vehicleId || vehicle.vehicleId?.toString().startsWith("9")) {
      return null;
    }
    return 'https://res.cloudinary.com/carfinance247-co-uk/image/upload/q_30/v1/' + vehicle.vehicleId + '/1.webp'
  }


return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (__props.vehicle && __props.vehicle.image)
    ? (_openBlock(), _createBlock(_component_q_avatar, {
        key: 0,
        size: __props.size
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_img, {
            src: __props.vehicle.image,
            fit: "cover",
            loading: "lazy",
            height: "100%"
          }, {
            error: _withCtx(() => [
              _createVNode(_component_q_img, {
                class: "full-height",
                fit: "cover",
                loading: "lazy",
                src: require('assets/img/no-image.png')
              }, null, 8, ["src"])
            ]),
            _: 1
          }, 8, ["src"]),
          (__props.approved > 0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "white",
                floating: "",
                rounded: "",
                style: {"height":"21px","width":"21px","padding":"3px !important"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_badge, {
                    rounded: "",
                    style: {"height":"15px","width":"15px","padding":"0px !important"},
                    class: "flex items-center justify-center",
                    dense: "",
                    color: __props.approved === 3 ? 'positive' : 'negative'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: __props.approved === 3 ? 'mdi-check' : 'mdi-close',
                        style: {"font-size":"10px"},
                        color: "white"
                      }, null, 8, ["name"])
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["size"]))
    : (__props.vehicle && __props.vehicle.vehicleId)
      ? (_openBlock(), _createBlock(_component_q_avatar, {
          key: 1,
          size: __props.size
        }, {
          default: _withCtx(() => [
            (vehicleImage(__props.vehicle))
              ? (_openBlock(), _createBlock(_component_q_img, {
                  key: 0,
                  src: vehicleImage(__props.vehicle),
                  fit: "cover",
                  loading: "lazy",
                  height: "100%"
                }, {
                  error: _withCtx(() => [
                    _createVNode(_component_q_img, {
                      class: "full-height",
                      fit: "cover",
                      loading: "lazy",
                      src: require('assets/img/no-image.png')
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["src"]))
              : (_openBlock(), _createBlock(_component_q_img, {
                  key: 1,
                  class: "full-height",
                  fit: "cover",
                  loading: "lazy",
                  src: require('assets/img/no-image.png')
                }, null, 8, ["src"])),
            (__props.approved > 0)
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 2,
                  color: "white",
                  floating: "",
                  rounded: "",
                  style: {"height":"21px","width":"21px","padding":"3px !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_badge, {
                      rounded: "",
                      style: {"height":"15px","width":"15px","padding":"0px !important"},
                      class: "flex items-center justify-center",
                      dense: "",
                      color: __props.approved === 3 ? 'positive' : 'negative'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: __props.approved === 3 ? 'mdi-check' : 'mdi-close',
                          style: {"font-size":"10px"},
                          color: "white"
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["size"]))
      : (_openBlock(), _createBlock(_component_q_avatar, {
          key: 2,
          size: __props.size
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_img, {
              src: require('assets/img/no-image.png'),
              loading: "lazy"
            }, null, 8, ["src"]),
            (__props.approved > 0)
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 0,
                  color: "white",
                  floating: "",
                  rounded: "",
                  style: {"height":"21px","width":"21px","padding":"3px !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_badge, {
                      rounded: "",
                      style: {"height":"15px","width":"15px","padding":"0px !important"},
                      class: "flex items-center justify-center",
                      dense: "",
                      color: __props.approved === 3 ? 'positive' : 'negative'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: __props.approved === 3 ? 'mdi-check' : 'mdi-close',
                          style: {"font-size":"10px"},
                          color: "white"
                        }, null, 8, ["name"])
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["size"]))
}
}

})